/* eslint-disable quotes */
/* eslint-disable max-len */
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingRequestDetailsModel } from '../../models/hearing-request-details.model';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
import { JscHearingRequestDocumentModel } from '../../models/jsc-hearing-request-document.model';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
@Component({
  selector: 'jsg-action-hearing-card-view',
  templateUrl: './action-hearing-card-view.component.html',
  styleUrls: ['./action-hearing-card-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionHearingCardViewComponent implements OnDestroy {
  @Input() hearingRequest: HearingRequestDetailsModel;
  @Input() isCommercialMatter: boolean = true;
  @Input() calendarRoute: string;
  @Input() associateMaterialsSupportText: string;
  @Input() associateMaterialsEmptyText: string;
  @Input() hearingRequestDocuments: JscHearingRequestDocumentModel[];

  @Output() back = new EventEmitter<string>();
  @Output()
  adjournButtonClick: EventEmitter<HearingRequestDetailsModel> = new EventEmitter<HearingRequestDetailsModel>();
  @Output() associateMaterials = new EventEmitter();
  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();
  @Output() downloadFiles = new EventEmitter<UploadMaterialMetadataModel[]>();
  @Output() cancelSpecial = new EventEmitter<HearingRequestDetailsModel>();

  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;
  documentsDisplayedColumns: string[] = ['documents', 'fileName'];

  private cancelAssociateMaterialsDialogSubscription: Subscription;
  constructor(private dialog: MatDialog) {}

  public onBackClick = () => {
    this.back.emit(this.hearingRequest?.action?.actionNumber);
  };

  public onAdjournButtonClick = () => {
    if (this.hearingRequest?.userHearingAccess?.canAdjourn) {
      this.cancelAssociateMaterialsDialogSubscription = this.dialog
        .open(ConfirmationDialogComponent, {
          autoFocus: false,
          disableClose: true,
          width: '600px',
          data: {
            caption: 'Request Adjournment',
            subcaption:
              "All parties will be required to re-associate their materials to the adjourned hearing once it's approved. Do you wish to proceed?",
            confirmButton: 'Yes, proceed',
            cancelButton: 'No, cancel',
          },
        })
        .afterClosed()
        .subscribe((isConfirmed: boolean) => {
          if (!isConfirmed) {
            return;
          }
          this.adjournButtonClick.emit(this.hearingRequest);
        });
    }
  };

  public onAssociateMaterials = () => {
    this.associateMaterials.emit();
  };

  public onOpenFile = (docToOpen: UploadMaterialMetadataModel) => {
    this.openFile.emit(docToOpen);
  };

  public onDownloadFiles = (files: UploadMaterialMetadataModel[]) => {
    this.downloadFiles.emit(files);
  };

  public onCancelSpecialClick = () => {
    this.cancelSpecial.emit(this.hearingRequest);
  };

  ngOnDestroy(): void {
    this.cancelAssociateMaterialsDialogSubscription?.unsubscribe();
  }
}
